import React from 'react';
import PropTypes from 'prop-types';

const RadioButtonNotSelected = ({
                                  fill, height, width, ...style
                                }) => (
  <svg version="1.1" x="0px" y="0px" height={height} width={width}
       viewBox="0 0 20.8 20.8" style={{enableBackground: 'new 0 0 20.8 20.8', style}}>
    <path id="Icon" style={{fill: fill}} d="M10.4,0.4c-5.5,0-10,4.5-10,10s4.5,10,10,10s10-4.5,10-10C20.4,4.9,15.9,0.4,10.4,0.4z M10.4,18.4
	c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8C18.4,14.8,14.8,18.4,10.4,18.4z"/>
  </svg>


);

RadioButtonNotSelected.propTypes = {
  fill: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  style: PropTypes.object,
};

RadioButtonNotSelected.defaultProps = {
  fill: '#A4ADC1',
  height: '20px',
  width: '20px',
  style: {width: '20px', height: '20px'},
};

export default RadioButtonNotSelected;



// WEBPACK FOOTER //
// ./src/components/RadioButtonNotSelected.jsx